import { authFetchGET, authFetchPOST } from '../utils/auth-fetch';

const env = (<any>window).appenv;

export interface Position {
    type: string;
    coordinates: number[][][];
}

export interface Rs6UpdateInfo{
    licensed:	boolean,
    week: string | null,
    position: Position;
}

export class Rs6Service {
    static async getUpdateInfo(): Promise<Map<string, Rs6UpdateInfo>> {
        const enableTides = (<any>window)["appenv"]?.featureToggles?.tides;
        if (!enableTides) {
            return new Map();
        }
        const result = await authFetchGET(env.scope, `${env.services.rs6.baseurl}/updateInfo`);
        return new Map(Object.entries(result));;
    }
}